import updateCart from './updateCart';

function updateDeliveryType({ axios, cartId, pickUp }) {
  const payload = { pickUp, deliveryDate: { asap: true } };
  if (!pickUp) payload.addressPhone = '';

  return updateCart({
    axios,
    cartId,
    payload,
  });
}

export default updateDeliveryType;
